import React from "react";

const SelectInput = ({ label, description, options, value, onChange, multiple = false }) => {
  return (
    <div className="flex flex-col space-y-2">
      {label && <label className="text-gray-700 font-medium">{label}</label>}
      <select
        multiple={multiple}
        value={value}
        onChange={(e) => {
          const selectedValues = Array.from(e.target.selectedOptions, option => option.value);
          onChange(selectedValues);
        }}
        className="p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150 ease-in-out"
      >
        <option value="" disabled>Select an option</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {description && <p className="text-sm text-gray-500">{description}</p>}
    </div>
  );
};

export default SelectInput;
